import React from 'react';
import Hero from '../components/Hero';
import Mission from '../components/Mission';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import Process from '../components/Process';

const Home: React.FC = () => {
  return (
    <div>
      <Hero />
      <Mission />
      <Services />
      <Portfolio />
      <Process />
      <section className="py-20 bg-black text-center relative overflow-hidden">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold text-gold-400 mb-6">Let's Build What Your Business Needs</h2>
          <p className="text-gray-300 max-w-2xl mx-auto mb-8">
            Whether you need a new website, a custom app, or AI that finally puts your data to work — Setora is the small-business software partner that ships. Tell us what you're trying to do.
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-3 bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-400 hover:to-gold-500 text-black font-semibold rounded-xl shadow-lg shadow-gold-500/30 transition-all duration-300"
          >
            Start a Project
          </a>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-gold-950/20 to-black/90" style={{ backgroundSize: 'auto 200%' }} />
      </section>
    </div>
  );
};

export default Home;
